@if ((updatingAuths && selectedOption !== 'customizeGroups') || (fetchingAuths && selectedOption === 'allGroups') || fetchingClients) {
<rs-loader></rs-loader>
}

<div class="multi-group-level">
    @if (errors) {
    <p class="error">{{errors}}</p>
    }
    @if (updatingAutherrors) {
    <p class="error">Errors updating authorizations: {{updatingAutherrors}}</p>
    }
    <div class="auth-options">
        @if (!alreadyUser) {
            <rs-checkbox color="secondary" id="convertToUser" name="convertToUser" label="Convert to user" value="convertToUser" (change)="alreadyUser = true"></rs-checkbox>
        }
        <rs-notification type="info" [visible]="selectedOption === 'allGroups'" message="Please keep in mind that the access noted below for ‘All groups’ may not be available for every group. For example, as the administrator, you may have access to Billing Reports for group A, but not for group B. In this case, selecting Billing Reports for all groups will not provide this user with Billing Reports for group B.  Your users will not receive a higher level of access than you when selecting this option."></rs-notification>
        @if (alreadyUser) {
            <rs-radio id="radio1" name="multipleClients" value="allGroups" label="Select for all Groups" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            <rs-radio id="radio2" name="multipleClients" value="customizeGroups" label="Select to customize Groups" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            @if (adminOnly.includes(userInfo().adminRole) && userInfo().selectedUserType.toLowerCase() !== 'delegate') {
            <rs-radio id="radio3" name="multipleClients" value="delegate" label="Create Delegate - a user who can create users and manage authorizations on your behalf" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            }
        }
    </div>
    <!-- Below is the holder for the all groups auth modifications -->
    @if (selectedOption && selectedOption === 'allGroups' && !errors && userAndAdminAuths.userRelatedAuthorizations.length && editAllGroupsForm) {
        <form [formGroup]="editAllGroupsForm">
            <table>
                <thead>
                    <th>Group ID</th>
                    <th>Group Name</th>
                    @if (userAndAdminAuths.adminRelatedAuthorizations.eligibilityAccessLevel) {
                    <th>
                        <span>Eligibility Access</span>
                        <rs-select id="adminEligAccess" formControlName="adminEligAccess" [items]="eligAccessLevelOptions"  [attr.role]="'combobox'" aria-expanded="false" (change)="syncAllGroupValue('adminEligAccess', 'userEligAccess', true)"></rs-select>
                    </th>
                    }
                    @if (userAndAdminAuths.adminRelatedAuthorizations.clientKnowledgeIndicator) {
                    <th>
                        <span>Client Knowledge</span>
                        <rs-checkbox id="adminClientKnowledge" formControlName="adminClientKnowledge" (change)="syncAllGroupValue('adminClientKnowledge', 'userClientKnowledge')"></rs-checkbox>
                    </th>
                    }
                    @if (userAndAdminAuths.adminRelatedAuthorizations.customClientReportAccessIndicator) {
                    <th>
                      <span>Custom Client Reports</span>
                      <rs-checkbox id="adminCustomClientReport" formControlName="adminCustomClientReport" (change)="syncAllGroupValue('adminCustomClientReport', 'userCustomClientReportAccess')"></rs-checkbox>
                    </th>
                    }
                    @if (userAndAdminAuths.adminRelatedAuthorizations.billingReportAccessIndicator) {
                    <th>
                        <span>Billing Report</span>
                        <rs-checkbox id="adminBillingReport" formControlName="adminBillingReport" (change)="syncAllGroupValue('adminBillingReport', 'userBillingReport')"></rs-checkbox>
                    </th>
                    }
                    @if (userAndAdminAuths.adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                    <th>
                        <span>Claim Detail Report</span>
                        <rs-checkbox id="adminClientDetailReport" formControlName="adminClientDetailReport" (change)="syncAllGroupValue('adminClientDetailReport', 'userClientDetailReport')"></rs-checkbox>
                    </th>
                    }
                    @if (userAndAdminAuths.adminRelatedAuthorizations.satAccessLevel) {
                    <th>
                        <span>Sat Access Level</span>
                        <rs-select aria-expanded="false" [attr.role]="'combobox'" id="adminSatAccess" formControlName="adminSatAccess" [items]="satAccessLevelOptions" (change)="syncAllGroupValue('adminSatAccess', 'userSatAccess', true)"></rs-select>
                    </th>
                    }
                </thead>
                <tbody formGroupName="userAuthForm">
                    @for (user of userAndAdminAuths.userRelatedAuthorizations; track user.subGroupSpecifiedIdentifier) {
                    <tr>
                        <td>All</td>
                        <td>All Groups</td>
                        @if (userAndAdminAuths.adminRelatedAuthorizations.eligibilityAccessLevel) {
                        <td>
                            <rs-select formControlName="userEligAccess" [attr.role]="'combobox'" aria-expanded="false" [id]="user.subGroupSpecifiedIdentifier+'eligibilityAccessLevel'" [items]="eligAccessLevelOptions" (change)="refreshAllGroupDirtyState()"></rs-select>
                        </td>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.clientKnowledgeIndicator) {
                        <td>
                            <rs-checkbox formControlName="userClientKnowledge" [id]="user.subGroupSpecifiedIdentifier+'clientKnowledgeIndicator'" (change)="refreshAllGroupDirtyState()"></rs-checkbox>
                        </td>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.customClientReportAccessIndicator) {
                        <td>
                          <rs-checkbox formControlName="userCustomClientReportAccess" [id]="user.subGroupSpecifiedIdentifier+'customClientReportAccessIndicator'" (change)="refreshAllGroupDirtyState()"></rs-checkbox>
                        </td>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.billingReportAccessIndicator) {
                        <td>
                            <rs-checkbox formControlName="userBillingReport" [id]="user.subGroupSpecifiedIdentifier+'billingReportAccessIndicator'" (change)="refreshAllGroupDirtyState()"></rs-checkbox>
                        </td>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                        <td>
                            <rs-checkbox formControlName="userClientDetailReport" [id]="user.subGroupSpecifiedIdentifier+'claimDetailReportAccessIndicator'" (change)="refreshAllGroupDirtyState()"></rs-checkbox>
                        </td>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.satAccessLevel) {
                        <td>
                            <rs-select [attr.role]="'combobox'" aria-expanded="false" formControlName="userSatAccess" [id]="user.subGroupSpecifiedIdentifier+'satAccessLevel'" [items]="satAccessLevelOptions" (change)="refreshAllGroupDirtyState()"></rs-select>
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </form>
    }
    <!-- Below is the container to populate the admin groups -->
    @if (selectedOption === 'customizeGroups') {
    <div class="admin-clients-container">
        @for (clientsInfo of adminClientsInfo; track clientsInfo.planAcronym + ':' + clientsInfo.specifiedId) {
            @if (clientsInfo.specifiedId) {
                @if (errorsFetchingClients) {
                <p class="errors">Errors fetching clients: {{errorsFetchingClients}}</p>
                }
                <div class="admin-clients">
                    <button type="button" class="user-context" (click)="toggleTheClient(clientsInfo)">
                        <span class="context">
                            <span>Payer: </span>{{clientsInfo.planAcronym}}
                            <span>Group Name: </span>{{clientsInfo.name}}
                            <span>Group Id: </span>{{clientsInfo.specifiedId}}
                        </span>
                    </button>
                </div>
            }
        }
    </div>
    <rs-paginator [length]="totalRecords"
                (page)="getMoreClients($event)" showFirstLastButtons
                [pageSize]="defaultPageSize"></rs-paginator>
    }
    <!-- Save and Cancel buttons container -->
    <div class="btns-cont">
        @if (selectedOption && selectedOption !== 'customizeGroups') {
            <button rs-raised-button class="next-btn" [disabled]="alreadyUser && selectedOption === 'allGroups' && !authsModifiedForAllGroups" color="primary" (click)="manageAuthorizations()">Save</button>
        }
        <button rs-raised-button color="secondary" (click)="cancelGroupAuthEdit.emit(true)">Cancel</button>
    </div>
    <!-- Pop up to open the selected group auth options -->
    @if (selectedClient && selectedClient.specifiedId) {
        <rs-dialog [visible]="true" heading="Choose authorizations for the group" maxWidth="80%" class="group-auth-options" (visibleChange)="selectedClient = null">
            <div class="group-auth-options-content">
                <div class="context">
                    <span>Admin Payer: </span>{{userInfo().contextOfAdmin.split('/')[0]}}
                    <span>Payer: </span>{{selectedClient.planAcronym}}
                    <span>Group Name: </span>{{selectedClient.name}}
                    <span>Group Id: </span>{{selectedClient.specifiedId}}
                </div>
                <bmt-manage-auth-at-group (viewAuthorizations)="cancelGroupAuthEdit.emit(true)" (cancelGroupAuthEdit)="selectedClient = null" [userInfo]="userInfoForPopUp"></bmt-manage-auth-at-group>
            </div>
        </rs-dialog>
    }
    <!-- Popup of saved auth confirmations -->
    <rs-dialog [visible]="showUpdateDialog && updatingAuthsResp && !updatingAuths" heading="User Authorizations" maxWidth="60%" class="bmt-manager-user-auth" (visibleChange)="handleUpdateDialogVisibility($event)">
        <div style="padding: 20px;">
            <p>
                User authorizations are updated
            </p>
        </div>
        <div style="padding: 20px;justify-content: space-between;display: flex;">
            <button style="width: auto;" rs-raised-button color="primary" (click)="viewUpdatedAuthorizations()">View authorizations</button>
            <button style="width: auto;" rs-raised-button color="primary" (click)="navigateToUserAdmin()">Manage other User</button>
        </div>
    </rs-dialog>
</div>
